<script>
// Customer-Service variant of FilterDialogInAdmin.
// Reuses the full template, data, computed, watchers, lifecycle and
// `searchRequest` flow from FilterDialogInAdmin via `extends`, and ONLY
// overrides `setTblData` so the rows produced after a search match the
// columns rendered by CustomerServiceRequests.vue (cs_combined,
// agent_combined, sm_combined, fm_combined, mm_combined, cs_date, ...).
import FilterDialogInAdmin from "@/components/Charts/FilterDialogInAdmin.vue";
import { formatDate } from "@/mixins/formatDate";
import { SourceValue } from "@/mixins/sourceValue";

const adminSideStatuses = ["admin_side", "cs_side"];

export default {
  name: "FilterDialogInAdminCS",
  extends: FilterDialogInAdmin,

  methods: {
    setTblData(res) {
      const isOnAdminOrCsSide = adminSideStatuses.includes(
        res.customer_services_status
      );

      const newItem = {
        id: res.id,
        isSelected: false,
        "رقم الطلب": res.id,
        created_at: res.created_at ? formatDate(res.created_at) : "",
        type: res.type || "لا_يوجد",
        req_product_type:
          this.selected_products_list.find(
            (item) => item.id === res.req_product_type
          )?.value || "لا_يوجد",

        customer_service_name: res.customer_service?.name ?? null,
        customer_name: res.customer?.name,
        customer_mobile: res.customer?.mobile,
        status: res.status,
        source: SourceValue(res.source),

        class_id_agent: res.class_id_agent ?? null,
        class_id_agent_text: isOnAdminOrCsSide
          ? null
          : res.class_id_agent_text ?? null,
        agent_notes: isOnAdminOrCsSide
          ? null
          : res.agent_notes ?? res.agent_note ?? res.comment ?? null,
        agent_name: isOnAdminOrCsSide
          ? null
          : res.agent_name ?? res.user?.name ?? null,

        class_id_cs: res.class_id_cs ?? null,
        class_id_cs_text: res.class_id_cs_text ?? null,
        class_id_cs_color: res.class_id_cs_color ?? null,
        cs_note: res.cs_note ?? res.customer_service_note ?? null,
        customer_service_note_date: res.customer_service_note_date ?? null,
        cs_date: res.cs_date ? formatDate(res.cs_date) : "",

        sales_manager_name: res.sales_manager_name ?? null,
        class_id_sm_text: res.class_id_sm_text ?? null,
        class_id_sm_color: res.class_id_sm_color ?? null,
        sm_comment: res.sm_comment ?? null,
        sm_comment_date: res.sm_comment_date ?? null,

        funding_manager_name: res.funding_manager_name ?? null,
        class_id_fm_text: res.class_id_fm_text ?? null,
        class_id_fm_color: res.class_id_fm_color ?? null,
        fm_comment: res.fm_comment ?? null,
        fm_comment_date: res.fm_comment_date ?? null,

        mortgage_manager_name: res.mortgage_manager_name ?? null,
        class_id_mm_text: res.class_id_mm_text ?? null,
        class_id_mm_color: res.class_id_mm_color ?? null,
        mm_comment: res.mm_comment ?? null,
        mm_comment_date: res.mm_comment_date ?? null,

        quality_notes: res.quality_notes,
        comment_date: res.comment_date,
        quacomment_date: res.quacomment_date,
        request_description:
          res.requestDescription?.option || res.request_description_other,
        situation_improve_date: res.situation_improve_date
          ? formatDate(res.situation_improve_date)
          : "",
        العمليات: res.sent_basket?.count,
      };

      const exists = this.$store.state.tableData.some(
        (item) => item.id === newItem.id
      );

      if (!exists) {
        this.$store.state.tableData.push(newItem);
      }
    },
  },
};
</script>
